export default {
  personalInformation: 'Personal Information',
  aboutProgram: 'About the Program',
  jobAlert: 'Job Alert',
  jobList: 'Job List',
  changeEmail: 'Change Email',
  bindEmail: 'Email Connect',
  changeMobile: 'Change Mobile (China only)',
  bindMobile: 'Mobile Connect (China only)',
  changePassword: 'Change Password',
  privacySetting: 'My Privacy Settings',
  finishProfile: 'Finish Profile',
  myPersonalDashboard: 'Dashboard',
  myApplication: 'My Applications',
  myProfile: 'My Profile',
  myReport: 'My Report',
  completedApplication: 'Completed Applications',
  incompleteApplication: 'Incomplete Applications',
  policy: 'My Consent',
  myReferralAndRewards: 'Track Referral Rewards',
  assessment: 'Assessment',
  applicationHistory: 'Application History',
  leads: 'Leads',
  dashboard: 'Dashboard',
  rewards: 'Rewards',
  referralProgram: 'About Referral Program',
  leaded: 'My Referrals',
  applied: 'Applied Candidate',
  hidden: 'Hidden Candidate',
  leaderBoard: 'Leaderboard',
  group: {
    referrals: 'REFERRALS',
    functions: 'FUNCTIONS',
    operationCenter: 'My Applications',
    dashboard: 'DASHBOARD'
  },
  tooltip: {
    finishProfile: 'Please finish your profile',
    processApplication: '{count} job application(s) require your further action to successfully complete',
    jobAlert: 'Job Alert',
    logout: 'Sign Out'
  },
  logout: 'Sign Out',
  mobile: {
    careerSite: 'Career Site',
    jobsList: 'Jobs List',
    allJobs: 'All Jobs',
    companyJobsList: '{company} Jobs',
    myReferrals: 'My Referrals',
    leads: 'Leads',
    dashboard: 'Dashboard',
    rewards: 'Rewards',
    leaderBoard: 'Leaderboard',
    referralProgram: 'About Referral Program',
    accountManagement: 'Account Management'
  }
}
